<div class="header">
  <h2 class="title">Add Participant</h2>
</div>

<mat-dialog-content>
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <!-- Add Pair Tab -->
    <mat-tab label="Add Pair">
      <div class="form-container">
        <form [formGroup]="pairForm" (ngSubmit)="submitPair()" class="pair-form-container">
          <!-- Recipient and Donor Side by Side -->
          <div class="participants-row">
            <!-- Recipient Section (LEFT) -->
            <div class="participant-section">
              <h3>Recipient</h3>

              <mat-form-field appearance="fill">
                <mat-label>Recipient ET nr</mat-label>
                <input matInput formControlName="recipientEnisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
                <mat-error *ngIf="pairForm.get('recipientEnisNumber')?.hasError('required')"> Required </mat-error>
                <mat-error *ngIf="pairForm.get('recipientEnisNumber')?.hasError('pattern') && !pairForm.get('recipientEnisNumber')?.hasError('required')"> Only digits </mat-error>
                <mat-error *ngIf="pairForm.get('recipientEnisNumber')?.hasError('minlength')"> Min 5 digits </mat-error>
                <mat-error *ngIf="pairForm.get('recipientEnisNumber')?.hasError('maxlength')"> Max 6 digits </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Date of Birth</mat-label>
                <input matInput [matDatepicker]="recipientDobPicker" formControlName="recipientDob" placeholder="DD/MM/YYYY" />
                <mat-datepicker-toggle matSuffix [for]="recipientDobPicker"></mat-datepicker-toggle>
                <mat-datepicker #recipientDobPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Center</mat-label>
                <mat-select formControlName="recipientCenter" placeholder="Select a center">
                  <mat-option *ngFor="let center of assignableCenters" [value]="center"> {{ center.name }} ({{ center.fullName }}) </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Donor Section (RIGHT) -->
            <div class="participant-section">
              <div class="donor-header">
                <h3>Donor</h3>
                <div class="donor-tabs" *ngIf="donorFormsArray.length > 1">
                  <button type="button" mat-button *ngFor="let d of donorFormsArray.controls; let i = index"
                          [class.active]="currentDonorIndex === i"
                          (click)="switchDonor(i)"
                          class="donor-tab-button">
                    Donor {{ i + 1 }}
                  </button>
                </div>
              </div>

              <!-- Donor Forms -->
              <div formArrayName="donors">
                <div *ngFor="let donorForm of donorFormsArray.controls; let i = index" [formGroupName]="i"
                     [style.display]="currentDonorIndex === i ? 'block' : 'none'">

                  <mat-form-field appearance="fill" >
                    <mat-label>Donor ET nr</mat-label>
                    <input matInput formControlName="enisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
                    <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('required')"> Required </mat-error>
                    <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('pattern') && !donorForm.get('enisNumber')?.hasError('required')"> Only digits </mat-error>
                    <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('minlength')"> Min 5 digits </mat-error>
                    <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('maxlength')"> Max 6 digits </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="fill" style="margin-top: 12px;">
                    <mat-label>Date of Birth</mat-label>
                    <input matInput [matDatepicker]="donorDobPicker" formControlName="dob" placeholder="DD/MM/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="donorDobPicker"></mat-datepicker-toggle>
                    <mat-datepicker #donorDobPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="fill" style="margin-top: 12px;">
                    <mat-label>Center</mat-label>
                    <mat-select formControlName="center" placeholder="Select a center">
                      <mat-option *ngFor="let center of assignableCenters" [value]="center"> {{ center.name }} ({{ center.fullName }}) </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" style="margin-top: 12px;">
                    <mat-label>Relation To Recipient</mat-label>
                    <mat-select formControlName="relationToRecipient">
                      <mat-option *ngFor="let relation of relations" [value]="relation">
                        {{ relation }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="donor-actions">
                    <button type="button" mat-raised-button color="primary"
                            *ngIf="i === donorFormsArray.length - 1 && donorFormsArray.length < 3"
                            (click)="addAnotherDonor()"
                            class="add-donor-button">
                      Add another donor
                    </button>
                    <button type="button" mat-raised-button color="warn"
                            *ngIf="donorFormsArray.length > 1"
                            (click)="removeDonor(i)"
                            class="remove-donor-button">
                      Remove this donor
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom Section: Comments and Checkboxes -->
          <div class="pair-bottom-section">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Comments</mat-label>
              <textarea matInput formControlName="comments"></textarea>
            </mat-form-field>

            <div class="checkbox-section">
              <mat-checkbox formControlName="compatible">Compatible</mat-checkbox>
              <mat-checkbox formControlName="addPairToMatchingPeriod" *ngIf="currentMatchingPeriod">Set active</mat-checkbox>
            </div>

            <div class="form-actions">
              <button mat-raised-button color="accent" type="submit" [disabled]="!pairForm.valid">Submit Pair</button>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>

    <!-- Add Solo Donor Tab -->
    <mat-tab label="Add Donor">
      <div class="form-container">
        <form [formGroup]="donorForm" (ngSubmit)="submitDonor()">
          <mat-form-field appearance="fill">
            <mat-label>ENIS Number</mat-label>
            <input matInput formControlName="enisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
            <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('required')"> ENIS Number is required </mat-error>
            <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('pattern') && !donorForm.get('enisNumber')?.hasError('required')"> ENIS Number must contain only digits </mat-error>
            <mat-error *ngIf="donorForm.get('enisNumber')?.hasError('minlength') && !donorForm.get('enisNumber')?.hasError('required') && !donorForm.get('enisNumber')?.hasError('pattern')">
              ENIS Number must be at least 5 digits long
            </mat-error>
            <mat-error
              *ngIf="
                donorForm.get('enisNumber')?.hasError('maxlength') &&
                !donorForm.get('enisNumber')?.hasError('required') &&
                !donorForm.get('enisNumber')?.hasError('pattern') &&
                !donorForm.get('enisNumber')?.hasError('minlength')
              "
            >
              ENIS Number must be at most 6 digits long
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" >
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="dobpicker1" formControlName="dob" placeholder="DD/MM/YYYY" />
            <mat-datepicker-toggle matSuffix [for]="dobpicker1"></mat-datepicker-toggle>
            <mat-datepicker #dobpicker1></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Center</mat-label>
            <mat-select formControlName="center" placeholder="Select a center">
              <mat-option *ngFor="let center of assignableCenters" [value]="center"> {{ center.name }} ({{ center.fullName }}) </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox formControlName="altruist"> Altruist </mat-checkbox>

          <div *ngIf="donorForm.get('altruist')?.value">
            <mat-checkbox formControlName="active"> Active </mat-checkbox>
          </div>

          <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" [disabled]="!donorForm.valid">Submit Donor</button>
          </div>
        </form>
      </div>
    </mat-tab>

    <!-- Add Solo Recipient Tab -->
    <mat-tab label="Add Recipient">
      <div class="form-container">
        <form [formGroup]="recipientForm" (ngSubmit)="submitRecipient()">
          <mat-form-field appearance="fill">
            <mat-label>ENIS Number</mat-label>
            <input matInput formControlName="enisNumber" placeholder="ENIS Number" type="text" maxlength="6" pattern="[0-9]*" />
            <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('required')"> ENIS Number is required </mat-error>
            <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('pattern') && !recipientForm.get('enisNumber')?.hasError('required')"> ENIS Number must contain only digits </mat-error>
            <mat-error *ngIf="recipientForm.get('enisNumber')?.hasError('minlength') && !recipientForm.get('enisNumber')?.hasError('required') && !recipientForm.get('enisNumber')?.hasError('pattern')">
              ENIS Number must be at least 5 digits long
            </mat-error>
            <mat-error
              *ngIf="
                recipientForm.get('enisNumber')?.hasError('maxlength') &&
                !recipientForm.get('enisNumber')?.hasError('required') &&
                !recipientForm.get('enisNumber')?.hasError('pattern') &&
                !recipientForm.get('enisNumber')?.hasError('minlength')
              "
            >
              ENIS Number must be at most 6 digits long
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="dobpicker2" formControlName="dob" placeholder="DD/MM/YYYY" />
            <mat-datepicker-toggle matSuffix [for]="dobpicker2"></mat-datepicker-toggle>
            <mat-datepicker #dobpicker2></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Center</mat-label>
            <mat-select formControlName="center" placeholder="Select a center">
              <mat-option *ngFor="let center of assignableCenters" [value]="center"> {{ center.name }} ({{ center.fullName }}) </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" [disabled]="!recipientForm.valid">Submit Recipient</button>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
